import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import classnames from 'classnames';
import { theme } from '../../../../global/theme';
import { ColorService } from 'common/services/color-service';
import { AnalyticsHelpers } from '../../analytics.helpers';
import './bar-chart.scss';
const colorService = new ColorService();
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
export const BarChartBlock = ({ barsColor, dataForRender, }) => {
    const intl = useIntl();
    const cn = AnalyticsHelpers.makeAnalyticsClass('chart');
    // Block of constants that can be easily transform in to component params
    const title = intl.formatMessage({
        id: 'account.analytics.usage.past-year',
    });
    const buttonsToSwitchViews = [
        {
            label: intl.formatMessage({ id: 'account.analytics.usage.sessions' }),
            key: 'totalSessionPerMonth',
        },
        {
            label: intl.formatMessage({ id: 'account.analytics.usage.minutes' }),
            key: 'totalDurationPerMonth',
        },
    ];
    const labelsForBarChart = dataForRender.map((item, index) => {
        const keyForTranslation = item.date
            .split(' ')[0]
            .slice(0, 3)
            .toLowerCase();
        const label = intl
            .formatMessage({ id: `account.analytics.months.${keyForTranslation}` })
            .toUpperCase();
        return index === dataForRender.length - 1
            ? [
                label,
                `(${intl
                    .formatMessage({ id: 'account.analytics.usage.current' })
                    .toLowerCase()})`,
            ]
            : label;
    });
    const [keyToShow, setKeyToShow] = useState((buttonsToSwitchViews[0] || {}).key);
    const onSwitcherClick = (item) => {
        setKeyToShow(item.key);
    };
    //Setting properties for Bar Chart
    const backgroundColor = dataForRender.map((item, index) => {
        if (index === dataForRender.length - 1) {
            return colorService.getColorFromGradient([
                theme.Colors.white,
                theme.Colors.white,
                barsColor,
            ]);
        }
        return barsColor;
    });
    const minScale = 3;
    const data = dataForRender.map((item) => item[keyToShow]);
    const maxValue = Math.max(...data, minScale);
    const maxAmountOfLines = 3;
    const dataForChart = {
        labels: labelsForBarChart,
        datasets: [
            {
                data,
                backgroundColor,
            },
        ],
    };
    return (<>
      <h4 className={cn('title')}>{title}</h4>
      <Bar data={dataForChart} width={500} options={AnalyticsHelpers.getOption(maxValue, maxAmountOfLines, minScale)}/>
      <div className={cn('switcher-wrapper')}>
        {buttonsToSwitchViews.length > 1 &&
            buttonsToSwitchViews.map((item) => {
                if (item.key === keyToShow) {
                    return (<button className={classnames(cn('switcher'), cn('switcher--active'))} key={item.key} onClick={() => onSwitcherClick(item)}>
                  {item.label}
                </button>);
                }
                return (<button className={cn('switcher')} key={item.key} onClick={() => onSwitcherClick(item)}>
                {item.label}
              </button>);
            })}
      </div>
    </>);
};
